// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yf2x","content":"styles_content__3H3Gq"};